import { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const VENDOR_NAV = [
  { path: '/vendor',          label: 'Dashboard',     icon: '◈' },
  { path: '/vendor/profiles', label: 'My Profiles',   icon: '📋' },
  { path: '/vendor/new',      label: 'New Profile',   icon: '＋' },
];
const ADMIN_NAV = [
  { path: '/admin',           label: 'Dashboard',     icon: '◈' },
  { path: '/admin/profiles',  label: 'All Profiles',  icon: '📋' },
  { path: '/admin/expiring',  label: 'Expiring Soon', icon: '⏱' },
  { path: '/admin/users', label: 'User Management', icon: '👤' },
];

export default function AppShell({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [navOpen, setNavOpen] = useState(false);
  const nav = user?.role === 'vendor' ? VENDOR_NAV : ADMIN_NAV;

  function handleLogout() {
    logout();
    navigate('/login');
  }

  function handleNavClick() {
    setNavOpen(false);
  }

  return (
    <div className="app-shell">
      <header className="topbar">
        <button
          className="hamburger-btn"
          aria-label={navOpen ? 'Close navigation menu' : 'Open navigation menu'}
          aria-expanded={navOpen}
          onClick={() => setNavOpen(o => !o)}
        >
          <span />
          <span />
          <span />
        </button>
        <div className="topbar-logo">
          💧 AWWT Corp <span>/ Waste Profile Portal</span>
        </div>
        <div className="topbar-user">
          <span className="topbar-user-name">{user?.firstName} {user?.lastName}</span>
          <span className="tag" style={{ textTransform: 'capitalize' }}>{user?.role}</span>
          <button onClick={handleLogout}>Sign out</button>
        </div>
      </header>

      {navOpen && <div className="sidebar-overlay" onClick={() => setNavOpen(false)} />}

      <nav className={`sidebar ${navOpen ? 'nav-open' : ''}`}>
        <div className="sidebar-section" style={{ marginBottom: 8 }}>Navigation</div>
        {nav.map(item => (
          <Link key={item.path} to={item.path} style={{ textDecoration: 'none' }} onClick={handleNavClick}>
            <button
              className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
            >
              <span className="icon">{item.icon}</span>
              {item.label}
            </button>
          </Link>
        ))}
        <div style={{ flex: 1 }} />
        <div style={{ padding: '16px 20px', borderTop: '1px solid var(--border)', marginTop: 16 }}>
          <div style={{ fontSize: 11, color: 'var(--ink-lt)', lineHeight: 1.6 }}>
            <div style={{ fontWeight: 600, color: 'var(--ink-mid)' }}>{user?.companyName}</div>
            <div>{user?.email}</div>
          </div>
        </div>
      </nav>

      <main className="main-content">
        {children}
      </main>
    </div>
  );
}
